module.exports = {"341172001":"凤凰街道","341172002":"城北新区","341172401":"滁州市经济技术开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/341172.json
// module id = 1117
// module chunks = 0